import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { isPast, isFuture } from 'date-fns';
import cohortSummaryShape from 'Workspace/types/cohorts/cohortSummary';

import {
  MenuList,
  MaterialIcon,
  MenuListItem,
} from '@pearsontechnology/aero-components';

import { commandWorkspaceCohortArchive } from 'containers/ConnectionManager/actions';

import { intl } from 'containers/LanguageProvider/IntlGlobalProvider';

import {
  Menu,
  MenuListItemText,
} from './styles';
import messages from './messages';

class ActionMenu extends React.Component {
  deleteCohort = () => {
    const { cohortId } = this.props.cohort;
    this.props.deleteCohort(cohortId);
  };

  moreMenuItem(iconId, message, clickHandler) {
    return (
      <MenuListItem key={iconId} onClick={clickHandler}>
        <MaterialIcon id={iconId} />
        <MenuListItemText>
          {intl.formatMessage(message)}
        </MenuListItemText>
      </MenuListItem>
    );
  }

  generateActionMenuItems() {
    const { cohort } = this.props;

    if (!!cohort.finishedDate || isPast(cohort.endDate)) {
      return [
        this.moreMenuItem('autorenew', messages.listMoreOptionRestart),
        this.moreMenuItem('file_copy', messages.listMoreOptionDuplicate),
      ];
    } else if (isFuture(cohort.startDate) && !cohort.enrollmentsCount) {
      return [
        this.moreMenuItem('file_copy', messages.listMoreOptionDuplicate),
        this.moreMenuItem('delete', messages.listMoreOptionDelete, this.deleteCohort),
      ];
    }
    return [
      this.moreMenuItem('file_copy', messages.listMoreOptionDuplicate),
    ];
  }

  render() {
    return (
      <Menu>
        <MenuList>
          {this.generateActionMenuItems()}
        </MenuList>
      </Menu>
    );
  }
}

ActionMenu.propTypes = {
  cohort: cohortSummaryShape,
  deleteCohort: PropTypes.func,
};

const mapDispatchToProps = (dispatch) => ({
  deleteCohort: (cohortId) => dispatch(commandWorkspaceCohortArchive(cohortId)),
});

export default connect(null, mapDispatchToProps)(ActionMenu);
